import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export const initializeBackgrounds = createAction(`${actionKey}.INIT`, ()=>({}));
export const saveBackground = createAction(`${actionKey}.SAVE_BACKGROUND`, (deviation, backgroundId)=>({
        deviation,
        backgroundId
    }));
export const saveBackgroundSuccess = createAction(`${actionKey}.SAVE_BACKGROUND.SUCCESS`, (deviationId, backgroundId)=>({
        deviationId,
        backgroundId
    }));
export const saveBackgroundFail = createAction(`${actionKey}.SAVE_BACKGROUND.FAIL`, (deviationId, backgroundId)=>({
        deviationId,
        backgroundId
    }));
export const setBackground = createAction(`${actionKey}.SET_BACKGROUND`, (deviationId, backgroundId)=>({
        deviationId,
        backgroundId
    }));
export const showBackgroundPicker = createAction(`${actionKey}.SHOW_BG_PICKER`, (deviation)=>({
        deviation
    }));
export const fetchBackgrounds = createAction(`${actionKey}.FETCH_BACKGROUNDS`, ()=>({}));
export const previewBackground = createAction(`${actionKey}.PREVIEW_BACKGROUND`, (backgroundId)=>({
        backgroundId
    }));

//# sourceMappingURL=actions.js.map